import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceApiModel } from './abstract-service-api.model';
import { locationServiceEndpoint } from 'app/order-management/config/sdks/locations-service.config';

export const signinEndpoint = '/signin';
export const signupEndpoint = '/signup';
export const usersEndpoint = '/users';
export const organizationsEndpoint = '/organizations';
export const brandsEndpoint = '/brands';
export const downloadsEndpoint = '/downloads';
export const uploadsEndpoint = '/uploads';
export const filesEndpoint = '/files';
export const imagesEndpoint = '/images';
export const orderImagesEndpoint = '/images/order';
export const referralImagesEndpoint = '/images/referral';
export const marketingFilesEndpoint = '/marketing-files';
export const newsEndpoint = '/news';
export const productsEndpoint = '/products';
export const accessEndpoint = '/access';
export const invitationsEndpoint = '/invitations';
export const reorderEndpoint = '/reorder';
export const preorderEndpoint = '/preorder';
export const preorderDraftEndpoint = '/preorder-drafts';
export const buyingSelectionEndpoint = '/buying-selections';
export const retailerSearchEndpoint = '/reorder/search';
export const updatesEndpoint = '/updates';
export const orderEndpoint = '/orders';
export const orderHistoryEndpoint = '/order-history';
export const autoRestockEndpoint = '/auto-restock';
export const suggestionEndpoint = '/suggestions';
export const insightsEndpoint = '/insights';
export const referralEndpoint = '/referral';
export const catalogEndpoint = '/article-collections';
export const landingPageEndpoint = '/landing-page';
export const exclusiveCatalogsEndpoint = '/article-collections/exclusive';
export const downloadSettings = '/download-settings';
export const appUsersEndpoint = '/app-users';
export const translationsEndpoint = '/translations';
export const exidsEndpoint = `${locationServiceEndpoint}/exids`;
export const akasEndpoint = `${locationServiceEndpoint}/akas`;

@Injectable()
export class ApiModel extends ServiceApiModel {
    constructor(http: HttpClient) {
        super(http);
    }

    public getSigninEndpoint(): string {
        return signinEndpoint;
    }

    public getSignupEndpoint(): string {
        return signupEndpoint;
    }

    public getUsersEndpoint(): string {
        return usersEndpoint;
    }

    public getOrganizationsEndpoint(): string {
        return organizationsEndpoint;
    }

    public getBrandsEndpoint(): string {
        return brandsEndpoint;
    }

    public getDownloadsEndpoint(): string {
        return downloadsEndpoint;
    }

    public getUploadsEndpoint(): string {
        return uploadsEndpoint;
    }

    public getFilesEndpoint(): string {
        return filesEndpoint;
    }

    public getImagesEndpoint(): string {
        return imagesEndpoint;
    }

    public getNewsEndpoint(): string {
        return newsEndpoint;
    }

    public getProductsEndpoint(): string {
        return productsEndpoint;
    }

    public getAccessEndpoint(): string {
        return accessEndpoint;
    }

    public getInvitationsEndpoint(): string {
        return invitationsEndpoint;
    }

    public getReorderEndpoint(): string {
        return reorderEndpoint;
    }

    public getPreorderEndpoint(): string {
        return preorderEndpoint;
    }

    public getPreorderDraftEndpoint(): string {
        return preorderDraftEndpoint;
    }

    public getBuyingSelectionEndpoint(): string {
        return buyingSelectionEndpoint;
    }

    public getRetailerSearchEndpoint(): string {
        return retailerSearchEndpoint;
    }

    public getUpdatesEndpoint(): string {
        return updatesEndpoint;
    }

    public getOrderEndpoint(): string {
        return orderEndpoint;
    }

    public getOrderHistoryEndpoint(): string {
        return orderHistoryEndpoint;
    }

    public getAutoRestockEndpoint(): string {
        return autoRestockEndpoint;
    }

    public getSuggestionEndpoint(): string {
        return suggestionEndpoint;
    }

    public getInsightsEndpoint(): string {
        return insightsEndpoint;
    }

    public getReferralEndpoint(): string {
        return referralEndpoint;
    }

    public getCatalogEndpoint(): string {
        return catalogEndpoint;
    }

    public getExclusiveCatalogsEndpoint(): string {
        return exclusiveCatalogsEndpoint;
    }

    public getDownloadSettingsEndpoint(): string {
        return downloadSettings;
    }

    public getLandingPageEndpoint(): string {
        return landingPageEndpoint;
    }

    public getAppUsersEndpoint(): string {
        return appUsersEndpoint;
    }

    public getTranslationsEndpoint(): string {
        return translationsEndpoint;
    }

    public getExidsEndpoint(): string {
        return exidsEndpoint;
    }

    public getAkasEndpoint(): string {
        return akasEndpoint;
    }
}
